import React from 'react';
import { Box, AppBar, Toolbar, Typography, Container, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import SectionLibrary from './SectionLibrary/SectionLibrary';

export default function SectionLibraryPreview() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      {/* Preview Header */}
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Section Library Preview
          </Typography>
          <Button 
            component={Link} 
            to="/" 
            color="primary"
          >
            Back to Home
          </Button>
        </Toolbar>
      </AppBar>

      {/* Preview Container */}
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Box sx={{ 
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 1,
          overflow: 'hidden'
        }}>
          <SectionLibrary />
        </Box>
      </Container>
    </Box>
  );
} 